module.exports = __webpack_public_path__ + "static/media/IMG_3994 va nity birds eye.433ba846.JPG";